import { combineReducers } from "redux";

import services from "../features/admin/serviceinquiry/service/Slice";

const servicess = combineReducers({
  services,
});

export default servicess;
